import { genCleanCamelCaseId } from "@okf/ootils";

/**
 * Build the DirectDataImport `schemaConfig` from a saved pending import, so a
 * resumed session lands straight on the import-config screen. Mirrors the shape
 * produced by the fresh upload / external-fetch flows (outline + fileNameInGcs
 * + metadata); existingFields/sampleData are empty because a resumed draft
 * re-derives them lazily.
 *
 * tplConfigs is seeded off the draft's name so the Confirm Import modal opens
 * prefilled instead of blank. It stays editable there — the modal holds its own
 * copy, and a rename regenerates contentType, so the user can still change the
 * dataset name before the import fires.
 *
 * Returns undefined when there's nothing to resume — safe to use directly as a
 * useState lazy initializer.
 */
export const buildSchemaConfigFromPendingDirectDataImport = (pendingDirectDataImport) =>
  pendingDirectDataImport
    ? {
        tplConfigs: {
          segment: "publishing",
          ...(pendingDirectDataImport.previewName
            ? {
                title: pendingDirectDataImport.previewName,
                contentType: genCleanCamelCaseId(
                  pendingDirectDataImport.previewName
                ),
              }
            : {}),
        },
        schemaExtractor: { outline: pendingDirectDataImport.schemaExtractorOutline },
        existingFields: [],
        sampleData: [],
        fileNameInGcs: pendingDirectDataImport.fileNameInGcs,
        metadata: pendingDirectDataImport.metadata || {},
        // Drafts of integration imports keep which integration fetched the
        // rows (saved into metadata by DirectDataImport), so resuming one still
        // links the dataset with the same schedule scope.
        ...(pendingDirectDataImport.metadata?.integration?.provider
          ? {
              integrationProvider: pendingDirectDataImport.metadata.integration.provider,
              adapterOptions: pendingDirectDataImport.metadata.integration.adapterOptions || {},
            }
          : {}),
      }
    : undefined;
